import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import axios from 'axios';
import { toast } from 'react-toastify';
import tableTextFilterMethod from '../../../utils/table-text-filter-method';
import AvaliadorModal from './AvaliadorModal';
import Table from '../Table';
import dictionary from '../../../dictionary';
import { toastConfig } from '../../../utils';
import { commaSeparatedDecimalSortMethod, dateSortMethod } from '../../../utils/relatorios';
import { API_URL, COTA_AVALIADOR_OPTIONS } from '../../../consts';
import { getError } from '../../../services/utils';
import { getAxiosConfig } from '../../../services';

const Avaliadores = ({
 users,
 onAction,
 currentUser,
 onCurrentUserChange,
 fetchingCurrentUser,
 fetchingUsers,
 statuses,
 suspensoes,
 fetchingSuspensoes,
 fetchingAproveitamento,
 showDSP,
 contador,
 tempo_adicional,
 onAlterarContador,
 showContador,
 showHistoricoSuspensao,
 showPolo,
 showTime,
 showCorrecoesHabilitadas,
 showCota,
 showStatus,
 showAlertas,
 showAproveitamento,
 showPreTeste,
 showLinkParaResumo,
 showAtualizacaoLote,
 history,
 mudarTimeAvaliador,
 cotaOptions,
 hierarquiasOptions,
 updateTable,
 avaliadoresSelecionados,
 selecionarAvaliador,
 selecionarTodosAvaliadores,
 onAcessarComo,
 showAcessarComo,
 podeHabilitarTerceira,
 noDataText,
 showRecapacitacao,
 enviarRecapacitacao,
 enviandoRecapacitacao,
}) => {
  const [userModalIsOpen, setUserModalIsOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleChangeUserTeam = (timeSelecionado, id) => {
    const value = { time_id: timeSelecionado.value };
    setSubmitting(true);
    axios.patch(`${API_URL}/correcoes/corretores/${id}`, value, getAxiosConfig())
      .then(() => {
        toast.success(dictionary.SUCESSO_PATCH, toastConfig);
        setUserModalIsOpen(false);
        updateTable();
      })
      .catch((error) => {
        const { status, data } = getError(error);
        if (status === 400 && data.non_field_errors) {
          toast.error(data.non_field_errors[0], toastConfig);
        } else if (status === 403) {
          toast.error(data.detail, toastConfig);
        } else {
          toast.error(dictionary.ERRO_PATCH_CORRETOR, toastConfig);
        }
      })
      .then(() => {
        setSubmitting(true);
      });
  };

  const openUserModal = (userId) => {
    setUserModalIsOpen(true);
    onCurrentUserChange(userId);
  };
  const getTrProps = (_, rowInfo) => {
    const statusColor = get(statuses.find(d => d.id === get(rowInfo, 'original.status')), 'cor');
    if (statusColor) {
      return { style: { backgroundColor: statusColor } };
    }
    return {};
  };

  const allChecked = users.length === avaliadoresSelecionados.length
  const usersIds = users.map(user => user.id)

  const columns = [
    {
      accessor: 'id',
      sortable: false,
      width: 50,
      show: showAtualizacaoLote,
      headerClassName: "d-block",
      Header: () => (
        <div className="d-flex align-items-center justify-content-center">
          <input
            type="checkbox"
            id="selectAll"
            checked={allChecked}
            onChange={() => {
              if (allChecked) {
                selecionarTodosAvaliadores([])
              } else {
                selecionarTodosAvaliadores(usersIds)
              }
            }}
          />
        </div>
      ),
      Cell: row => (
        <input
          type="checkbox"
          id={row.original.id}
          checked={avaliadoresSelecionados.includes(row.original.id)}
          onChange={() => selecionarAvaliador(row.original.id)}
        />
      ),
    },
    {
      accessor: 'hierarquia_responsavel',
      Header: 'Polo',
      show: showPolo,
    },
    {
      accessor: 'hierarquia',
      Header: 'Time',
      show: showTime,
    },
    {
      accessor: 'group',
      Header: 'Perfil',
    },
    {
      accessor: 'name',
      Header: 'Nome',
      minWidth: 210,
    },
    {
      Header: 'Correções habilitadas',
      show: showCorrecoesHabilitadas,
      minWidth: 180,
      Cell: row => (
        <div>
          <label>
            <input type="checkbox" onChange={e => onAction('change', row.original.id, { pode_corrigir_1: e.target.checked })} checked={row.original.pode_corrigir_1} /> 1ª
          </label>
          <label className="ml-4">
            <input type="checkbox" onChange={e => onAction('change', row.original.id, { pode_corrigir_2: e.target.checked })} checked={row.original.pode_corrigir_2} /> 2ª
          </label>
          {
            podeHabilitarTerceira && (
              <label className="ml-4">
                <input type="checkbox" onChange={e => onAction('change', row.original.id, { pode_corrigir_3: e.target.checked })} checked={row.original.pode_corrigir_3} /> 3ª
              </label>
            )
          }
        </div>
      ),
    },
    {
      Header: 'Cota',
      show: showCota,
      minWidth: 100,
      accessor: 'max_correcoes_dia',
      Cell: row => (
        <select className="form-control" value={row.value || ''} onChange={e => onAction('change', row.original.id, { max_correcoes_dia: e.target.value })}>
          {cotaOptions.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
        </select>
      ),
    },
    {
      accessor: 'status',
      Header: 'Status',
      show: showStatus,
      minWidth: 130,
      Cell: row => (
        <select className="form-control" value={row.value || ''} disabled={!get(statuses.find(d => row.value === d.id), 'pode_alterar', true)} onChange={e => onAction('statusChange', row.original.id, e.target.value)}>
          {statuses.filter(status => status.pode_alterar || row.value === status.id).map(d => <option key={d.id} value={d.id}>{d.descricao}</option>)}
        </select>
      ),
    },
    {
      accessor: 'ultima_correcao',
      Header: 'Última correção',
      sortMethod: dateSortMethod,
      minWidth: 150,
    },
    {
      accessor: 'alertas',
      Header: 'Alertas',
      show: showAlertas,
      Cell: row => (
        <Fragment>
          {
            get(row, 'value', []).map(alerta => (
              <div key={`${row.original.id}${alerta}`}>
                {alerta}
              </div>
            ))
          }
        </Fragment>
      ),
    },
    {
      accessor: 'corrigidas',
      Header: 'Corrigidas',
      minWidth: 120,
      Cell: (row) => {
        if (fetchingAproveitamento) {
          return <div className="loading-style text-center">carregando...</div>;
        }
        return <div>{row.value}</div>;
      },
    },
    {
      accessor: 'dsp',
      Header: 'DSP',
      minWidth: 120,
      sortMethod: commaSeparatedDecimalSortMethod,
      show: showDSP,
    },
    {
      accessor: 'aproveitamento',
      Header: 'Aprov.',
      show: showAproveitamento,
      minWidth: 120,
      sortMethod: commaSeparatedDecimalSortMethod,
      Cell: (row) => {
        if (fetchingAproveitamento) {
          return <div className="loading-style text-center">carregando...</div>;
        }
        return <div>{row.value}</div>;
      },
    },
    {
      accessor: 'pre_teste',
      Header: 'Nota do pré-teste',
      show: showPreTeste,
      sortMethod: commaSeparatedDecimalSortMethod,
      minWidth: 150,
    },
    {
      accessor: 'recapacitacao_habilitada_em',
      minWidth: 130,
      Header: 'Recapacitação',
      show: showRecapacitacao,
      Cell: row => {
        if (row.original.recapacitacao_criada_em) {
          return row.original.recapacitacao_criada_em;
        }
        if (row.original.recapacitacao_habilitada_em) {
          return (
            <button
              className={`btn btn-default ${enviandoRecapacitacao ? 'disabled' : ''}`}
              style={{ 'marginBottom': '4px', 'whiteSpace': 'normal'}}
              type="button"
              disabled={enviandoRecapacitacao}
              onClick={() => enviarRecapacitacao(row.original.id)}
            >
              {enviandoRecapacitacao ? 'Enviando...' : 'Refazer pré-teste'}
            </button>
          );
        }
        return '';
      }
    },
    {
      accessor: 'id',
      width: 100,
      Header: 'Resumo',
      show: showLinkParaResumo,
      Cell: row => (
        <button
          className="btn btn-default"
          type="button"
          onClick={() => history.push(`/resumo-correcoes/${row.value}?next=/v2/avaliadores`)}
        >
          <i className="fa fa-clipboard-list" />
        </button>
      ),
    },
    {
      accessor: 'id',
      width: 100,
      Cell: row => <button className="btn btn-default" type="button" onClick={() => openUserModal(row.original)}><i className="fa fa-eye" /></button>,
    },
  ];

  return (
    <Fragment>
      <Table
        data={users}
        columns={columns}
        pageSize={users.length < 30 ? users.length : 30}
        defaultFilterMethod={tableTextFilterMethod}
        showPageSizeOptions={false}
        showPagination={users.length > 0}
        loading={fetchingUsers}
        getTrProps={getTrProps}
        className="table-default table-v2-relatorios"
        NoDataComponent={({ children }) => fetchingUsers || <div className="table-empty-block">{children}</div>}
        noDataText={noDataText}
      />
      <AvaliadorModal
        submitting={submitting}
        mudarTimeAvaliador={mudarTimeAvaliador}
        onChangeUserTeam={handleChangeUserTeam}
        visible={userModalIsOpen}
        onClose={() => setUserModalIsOpen(!userModalIsOpen)}
        user={currentUser}
        suspensoes={suspensoes}
        fetchingSuspensoes={fetchingSuspensoes}
        fetchingUser={fetchingCurrentUser}
        contador={contador}
        tempo_adicional={tempo_adicional}
        onAlterarContador={onAlterarContador}
        showContador={showContador}
        hierarquiasOptions={hierarquiasOptions}
        showHistoricoSuspensao={showHistoricoSuspensao}
        onAcessarComo={onAcessarComo}
        showAcessarComo={showAcessarComo}
      />
    </Fragment>
  );
};

Avaliadores.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  onAction: PropTypes.func.isRequired,
  currentUser: PropTypes.oneOfType([PropTypes.object]).isRequired,
  onCurrentUserChange: PropTypes.func.isRequired,
  fetchingCurrentUser: PropTypes.bool.isRequired,
  fetchingUsers: PropTypes.bool.isRequired,
  statuses: PropTypes.arrayOf(PropTypes.object),
  suspensoes: PropTypes.arrayOf(PropTypes.shape({
    criado_em: PropTypes.string,
    excluido_em: PropTypes.string,
  })),
  fetchingSuspensoes: PropTypes.bool,
  fetchingAproveitamento: PropTypes.bool.isRequired,
  contador: PropTypes.number,
  tempo_adicional: PropTypes.string,
  onAlterarContador: PropTypes.func,
  showDSP: PropTypes.bool,
  showContador: PropTypes.bool,
  showHistoricoSuspensao: PropTypes.bool,
  showPolo: PropTypes.bool,
  showTime: PropTypes.bool,
  showCorrecoesHabilitadas: PropTypes.bool,
  showCota: PropTypes.bool,
  showStatus: PropTypes.bool,
  showAlertas: PropTypes.bool,
  showAproveitamento: PropTypes.bool,
  showPreTeste: PropTypes.bool,
  showLinkParaResumo: PropTypes.bool,
  history: PropTypes.shape().isRequired,
  mudarTimeAvaliador: PropTypes.bool,
  showAtualizacaoLote: PropTypes.bool,
  podeHabilitarTerceira: PropTypes.bool,
  noDataText: PropTypes.string,
  showRecapacitacao: PropTypes.bool,
  enviandoRecapacitacao: PropTypes.bool,
  enviarRecapacitacao: PropTypes.func,
  cotaOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
};


Avaliadores.defaultProps = {
  suspensoes: [],
  statuses: [],
  fetchingSuspensoes: false,
  contador: 0,
  tempo_adicional: '00:00:00',
  onAlterarContador: () => {},
  showDSP: false,
  showContador: false,
  showHistoricoSuspensao: false,
  showPolo: false,
  showTime: false,
  showCorrecoesHabilitadas: false,
  showCota: false,
  showStatus: false,
  showAlertas: false,
  showAproveitamento: false,
  showPreTeste: false,
  showLinkParaResumo: false,
  mudarTimeAvaliador: false,
  showAtualizacaoLote: false,
  podeHabilitarTerceira: false,
  showRecapacitacao: false,
  enviandoRecapacitacao: false,
  enviarRecapacitacao: () => {},
  cotaOptions: COTA_AVALIADOR_OPTIONS,
  noDataText: '',
};

export default Avaliadores;
